//extracted by mini-css-extract-plugin
export default {"notificationsPopover":"styles_notificationsPopover__JFDgM"};;